<template>
  <div v-if="isShow" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex justify-center items-center z-50 transition-all duration-300">
    <div class="relative bg-white/95 backdrop-blur-md w-full h-full flex flex-col overflow-hidden animate-popupFadeIn">
      
      <!-- Header -->
      <h2 class="relative w-full bg-brand p-4 text-center text-yellow-500 font-bold text-[16px] tracking-wide z-50 flex-shrink-0" style="background-color: var(--color-brand);">
        Danh sách hóa đơn/chứng từ
        <div class="absolute right-4 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/10 hover:bg-red-500 text-white/90 hover:text-white transition-colors flex items-center justify-center cursor-pointer shadow-sm" @click="closeModal">
            <font-awesome-icon :icon="['fas', 'xmark']" />
        </div>
      </h2>

      <!-- Bảng dữ liệu chứa Toolbar & Tabs -->
      <div class="flex-1 overflow-hidden flex flex-col bg-gray-50/50 relative pt-3">
        
        <!-- Header Ngang: Nút bên trái, Tabs bên phải -->
        <div class="flex flex-col lg:flex-row items-end justify-between border-b border-gray-300 w-full px-4 sm:px-6 shrink-0 z-10 relative">

          <!-- 3 Nút chức năng (Left) -->
          <div class="flex flex-wrap gap-2 sm:gap-3 items-center w-full lg:w-auto justify-start mb-3 lg:mb-1">
            <button @click="saveBatchUpdate" :disabled="!multipleSelection.length" 
              class="w-[31%] sm:w-auto px-4 py-2 h-[38px] bg-white border border-gray-200 text-brand hover:border-brand hover:bg-brand/5 hover:text-[#013b8f] disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed font-semibold rounded-xl shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-300 flex items-center justify-center gap-1.5 sm:gap-2 text-[13px] sm:text-[14px]">
              <font-awesome-icon :icon="['fas', 'check-double']" /> 
              <span>Lưu <span class="hidden sm:inline">Hợp Lệ</span><span v-if="multipleSelection.length && multipleSelection.length > 0"> ({{ multipleSelection.length }})</span></span>
            </button>
            <button @click="fetchData" 
              class="w-[31%] sm:w-auto px-4 py-2 h-[38px] bg-white border border-gray-200 text-teal-600 hover:border-teal-500 hover:bg-teal-50 hover:text-teal-700 font-semibold rounded-xl shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-300 flex items-center justify-center gap-1.5 sm:gap-2 text-[13px] sm:text-[14px]">
              <font-awesome-icon :icon="['fas', 'rotate-right']" /> 
              <span>Tải lại</span>
            </button>
            <button @click="isShowFilterPopup = true" 
              class="w-[31%] sm:w-auto px-4 py-2 h-[38px] bg-white border border-gray-200 text-gray-700 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-900 font-semibold rounded-xl shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-300 flex items-center justify-center gap-1.5 sm:gap-2 text-[13px] sm:text-[14px]">
              <font-awesome-icon :icon="['fas', 'filter']" /> 
              <span>Bộ lọc</span>
            </button>
            <button @click="exportExcel" 
              class="w-[31%] sm:w-auto px-4 py-2 h-[38px] bg-white border border-gray-200 text-green-600 hover:border-green-500 hover:bg-green-50 hover:text-green-700 font-semibold rounded-xl shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-300 flex items-center justify-center gap-1.5 sm:gap-2 text-[13px] sm:text-[14px]">
              <font-awesome-icon :icon="['fas', 'file-excel']" /> 
              <span>Tải Excel</span>
            </button>
          </div>

          <!-- Các Tab tệp tài liệu (Right) -->
          <div class="flex items-end justify-start lg:justify-end w-full lg:w-auto overflow-x-auto no-scrollbar mask-gradient pr-2">
            <div v-for="(item, index) in tabs" :key="index" @click="changeTab(item.value, index)"
              class="relative px-6 cursor-pointer flex items-center justify-center rounded-t-xl transition-all duration-200 min-w-[120px]"
              :class="[
                activeTab === item.value 
                  ? 'bg-white border border-gray-300 !border-b-white text-brand font-black z-20 h-[44px] shadow-[0_-3px_10px_rgba(0,0,0,0.03)] transform translate-y-[1px]' 
                  : 'bg-gray-100 border border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-gray-800 h-[38px] shadow-inner'
              ]"
              :style="{ marginLeft: index === 0 ? '0px' : '-16px', zIndex: activeTab === item.value ? 20 : (10 - index) }"
              >
              <el-badge v-if="badgesTab(item.value) !== 0" :value="badgesTab(item.value)" class="item mt-1">
                <div class="whitespace-nowrap text-[13px] tracking-wide">
                  {{ item.name }}
                </div>
              </el-badge>
              <div v-else class="whitespace-nowrap text-[13px] tracking-wide">{{ item.name }}</div>
            </div>
          </div>

        </div>

        <div class="flex-1 overflow-hidden bg-white flex flex-col p-4 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] ring-1 ring-gray-900/5 sm:rounded-b-2xl">


        <el-table
          :data="listBill"
          style="width: 100%"
          height="100%"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName"
          v-loading="loading"
          element-loading-text="Đang tải dữ liệu..."
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="code" label="Mã phiếu" width="130" sortable></el-table-column>
          <el-table-column prop="createdAt" label="Ngày tạo" width="120" sortable>
            <template slot-scope="{ row }">
              {{ formatDate(row.createdAt) }}
            </template>
          </el-table-column>
          <el-table-column label="Bộ phận" min-width="120">
             <template slot-scope="{ row }">
               {{ row.departments && row.departments.length ? row.departments[0].name : '' }}
             </template>
          </el-table-column>
          <el-table-column min-width="120" prop="formOfBill" label="Loại phiếu">
              <template slot-scope="{ row }">
                  {{ checkformBill(row.billType).label }}
              </template>
          </el-table-column>
          <el-table-column min-width="120" label="Công ty">
              <template slot-scope="{ row }">
                  {{ row.company }}
              </template>
          </el-table-column>
          <el-table-column min-width="120" label="Cửa hàng/ Nhà cung">
              <template slot-scope="{ row }">
                  {{ row.supplier }}
              </template>
          </el-table-column>
          <el-table-column align="center" label="Tổng tiền" width="140">
             <template slot-scope="{ row }">
                <span class="font-semibold text-brand">{{ formatVND(row.expense) }}</span>
             </template>
          </el-table-column>
          <el-table-column align="center" label="TT Ký" min-width="180">
             <template slot-scope="{ row }">
                <div class="flex flex-col gap-1 items-center justify-center py-1">
                    <el-tag size="mini" effect="plain" :type="isRoleSigned(row.departmentManager) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                        {{ isRoleSigned(row.departmentManager) ? 'Trưởng bộ phận đã ký' : 'Trưởng bộ phận chưa ký' }}
                    </el-tag>
                    <el-tag size="mini" effect="plain" :type="isRoleSigned(row.chiefAccountant) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                        {{ isRoleSigned(row.chiefAccountant) ? 'GĐTC đã ký' : 'GĐTC chưa ký' }}
                    </el-tag>
                    <el-tag size="mini" effect="plain" :type="isRoleSigned(row.reviewer) ? 'success' : 'info'" class="!whitespace-normal h-auto py-0.5 px-2 text-center border-opacity-60">
                        {{ isRoleSigned(row.reviewer) ? 'CEO đã ký' : 'CEO chưa ký' }}
                    </el-tag>
                </div>
             </template>
          </el-table-column>
          <el-table-column align="center" label="Hợp lệ" width="120">
             <template slot-scope="{ row }">
                <el-tag size="small" :type="row.isValid ? 'success' : 'info'" effect="plain" class="rounded-lg font-semibold">
                  {{ row.isValid ? 'Đã hợp lệ' : 'Chưa xử lý' }}
                </el-tag>
             </template>
          </el-table-column>
          <el-table-column align="center" label="Ngày chi thực tế" width="220">
             <template slot-scope="{ row }">
                <div class="flex items-center justify-center gap-1">
                  <el-date-picker
                    v-model="row.actualPaymentDate"
                    type="date"
                    placeholder="Chọn ngày"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    size="small"
                    class="!w-[140px]"
                  ></el-date-picker>
                  <el-button @click="updateActualPaymentDate(row)" size="small" type="primary" icon="el-icon-check" plain></el-button>
                </div>
             </template>
          </el-table-column>
          <el-table-column label="Thao tác" width="140" align="center">
            <template slot-scope="{ row }">
              <el-button @click="openBillDetail(row)" size="small" type="success" plain class="shadow-sm font-semibold rounded-lg hover:-translate-y-[1px] transition-transform duration-200">Mở phiếu</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-4 flex justify-between items-center text-center w-full bg-white pt-2 border-t shrink-0">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-sizes="[10, 20, 30, 50]"
              :page-size.sync="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
        </div>
      </div>
      </div>
      
      <!-- Popups -->
      <BillPopup v-if="isShowBill" :isShow="isShowBill" @closed="isShowBill = false" @reload="fetchData" :billdetail="billdetail" :isUpdateValidMode="true" />
      <FilterPanelPopup v-if="isShowFilterPopup" :isShow="isShowFilterPopup" :useGlobalState="false" :isHDHLMode="true" :initialFilters="mappedInitialFilters" @closed="onFilterClosed" />

    </div>
  </div>
</template>

<script>
const API_URL = process.env.VUE_APP_API_URL;
import moment from 'moment';
import dayjs from 'dayjs';
import BillPopup from './BillPopup.vue';
import FilterPanelPopup from './FilterPanelPopup.vue';

export default {
    components: { BillPopup, FilterPanelPopup },
    props: { isShow: Boolean },
    data() {
        return {
            loading: false,
            listBill: [],
            multipleSelection: [],
            isShowBill: false,
            isShowFilterPopup: false,
            billdetail: null,
            activeTab: 0,
            activeIndex: 0,
            currentPage: 1,
            pageSize: 10,
            total: 0,
            summary: {
                totalPending: 0,
                totalApproved: 0,
                totalRejected: 0
            },
            tabs: [
                { name: 'Xem xét', value: 0 },
                { name: 'Phê duyệt', value: 1 },
                { name: 'Đã chi', value: 2 },
                { name: 'Từ chối', value: 3 },
            ],
            rawDateRange: [
                dayjs().startOf("month").toDate(),
                dayjs().endOf("month").toDate()
            ],
            filters: {
                searchCode: null,
                timeRange: [
                    dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
                    dayjs().endOf("month").format("YYYY-MM-DD HH:mm:ss")
                ],
                departmentAdmin: null,
                formBills: null,
                selectedBillType: null,
                fillBillAddress: null,
                checkStatus: [],
                isValid: null,
                company: null,
                actualPaymentDateRange: null
            }
        }
    },
    computed: {
        underlineStyle() {
            const width = 100 / this.tabs.length;
            return {
                width: width + '%',
                left: this.activeIndex * width + '%',
            };
        },
        mappedInitialFilters() {
            return {
                selectedDateRange: this.filters.timeRange,
                departmentAdmin: this.filters.departmentAdmin,
                formBills: this.filters.formBills,
                searchCode: this.filters.searchCode,
                selectedBillType: this.filters.selectedBillType,
                checkStatus: this.filters.checkStatus,
                selectedValidStatus: this.filters.isValid,
                company: this.filters.company,
                actualPaymentDateRange: this.filters.actualPaymentDateRange
            }
        }
    },
    mounted() {
        this.fetchData();
        document.body.style.overflow = 'hidden';
    },
    beforeDestroy() {
        document.body.style.overflow = '';
    },
    methods: {
        closeModal() {
            this.$emit('closed');
        },
        async fetchData() {
            this.loading = true;
            try {
                // Tận dụng api get-list cơ bản kèm các filter vừa thêm
                const filterPayload = {
                    checkStatus: this.filters.checkStatus || [], // Lọc tab đã đảm nhiệm approvePaymentStatus, nhưng FilterPanelPopup truyền checkStatus status phiếu
                    searchCode: this.filters.searchCode || null,
                    timeRange: this.filters.timeRange || null,
                    departmentAdmin: this.filters.departmentAdmin || null,
                    formBills: this.filters.formBills || null,
                    approvePaymentStatus: this.activeTab,
                    billType: this.filters.selectedBillType || null,
                    fillBillAddress: this.filters.fillBillAddress || null,
                    isValid: this.filters.isValid !== undefined ? this.filters.isValid : null,
                    company: this.filters.company || null,
                    actualPaymentDateRange: this.filters.actualPaymentDateRange || null,
                    isHDHLMode: true
                };
                
                const res = await this.$axios.post(`${API_URL}/bill/get-list`, filterPayload, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` },
                    params: { page: this.currentPage, pageSize: this.pageSize }
                });
                if (res.data.success) {
                    this.listBill = res.data.data;
                    this.total = res.data.meta?.pagination?.total || 0;
                    this.summary = {
                        totalPending: res.data.summary?.totalPending || 0,
                        totalApproved: res.data.summary?.totalApproved || 0,
                        totalRejected: res.data.summary?.totalRejected || 0,
                    };
                }
            } catch (err) {
                console.error("Lỗi khi fetch data HDHL: ", err);
            } finally {
                this.loading = false;
            }
        },
        onFilter() {
            this.currentPage = 1;
            this.fetchData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.fetchData();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        changeTab(val, index) {
            this.activeTab = val;
            this.activeIndex = index;
            this.currentPage = 1;
            this.fetchData();
        },
        badgesTab(item) {
            return item === 0 ? this.summary.totalPending : (item === 1 ? this.summary.totalApproved : (item === 3 ? this.summary.totalRejected : 0));
        },
        handleDateChange(val) {
            // (Đã thay bằng FilterPanelPopup nên có thể loại bỏ hoặc giữ lại tham chiếu cũ, hiện tại không còn input Date Picker trên UI)
        },
        onFilterClosed(newFilters) {
            this.isShowFilterPopup = false;
            // newFilters là object nếu filter được submit hoặc xoá
            if (newFilters && typeof newFilters === 'object' && ('selectedDateRange' in newFilters)) {
                this.filters.timeRange = newFilters.selectedDateRange;
                this.filters.departmentAdmin = newFilters.departmentAdmin;
                this.filters.formBills = newFilters.formBills;
                this.filters.searchCode = newFilters.searchCode;
                this.filters.selectedBillType = newFilters.selectedBillType;
                this.filters.fillBillAddress = newFilters.fillBillAddressValue?.storeid || null;
                this.filters.checkStatus = newFilters.checkStatus || [];
                this.filters.isValid = newFilters.selectedValidStatus !== undefined ? newFilters.selectedValidStatus : null;
                this.filters.company = newFilters.company || null;
                this.filters.actualPaymentDateRange = newFilters.actualPaymentDateRange || null;
                
                this.onFilter();
            }
        },
        formatDate(date) {
            return moment(date).format('DD/MM/YYYY');
        },
        formatVND(amount) {
            return parseInt(amount || 0).toLocaleString("vi-VN", { style: "currency", currency: "VND" });
        },
        tableRowClassName({ row }) {
            if (row.formOfBill === 1) {
                return 'success-row';
            }
            return '';
        },
        isRoleSigned(field) {
            if (!field) return false;
            if (typeof field === 'object') {
                return field.sign === true || !!field.name;
            }
            return field === true;
        },
        checkformBill(e) {
            const type = this.$app.billTypes.find(item => item.value == e)
            return type ? { label: type.label, value: type.value } : { label: 'Không xác định', value: null };
        },
        openBillDetail(row) {
            this.billdetail = row;
            this.isShowBill = true;
        },
        async updateActualPaymentDate(row) {
            try {
                if (!row.actualPaymentDate) {
                    this.$notify.warning({ title: 'Cảnh báo', message: 'Vui lòng chọn ngày chi thực tế!' });
                    return;
                }
                const res = await this.$axios.put(`${API_URL}/bills/update/${row.id}`, {
                    type: 'actualPaymentDate',
                    data: row.actualPaymentDate
                }, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` }
                });
                if (res.data.success) {
                    this.$notify.success({ title: 'Thành công', message: 'Cập nhật ngày chi thực tế thành công!' });
                }
            } catch (error) {
                this.$notify.error({ title: 'Lỗi', message: 'Cập nhật ngày chi thực tế thất bại!' });
                console.error(error);
            }
        },
        async saveBatchUpdate() {
            if (!this.multipleSelection.length) return;
            try {
                await this.$confirm(`Bạn có chắc chắn muốn xác nhận HỢP LỆ cho ${this.multipleSelection.length} phiếu đã chọn?`, 'Xác nhận thao tác', {
                    confirmButtonText: 'Đồng ý',
                    cancelButtonText: 'Hủy',
                    type: 'warning'
                });
                
                const ids = this.multipleSelection.map(m => m.id);
                const res = await this.$axios.post(`${API_URL}/bills/batchUpdateValid`, { ids, isValid: true }, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` }
                });
                if (res.data.success) {
                    this.$notify.success({ title: 'Thành công', message: 'Cập nhật hàng loạt Hợp Lệ thành công!' });
                    this.fetchData();
                }
            } catch (error) {
                if (error !== 'cancel') {
                    this.$notify.error({ title: 'Lỗi', message: 'Cập nhật thất bại!' });
                    console.error(error);
                }
            }
        },
        async exportExcel() {
            try {
                this.$notify.info({ title: 'Đang xử lý', message: 'Đang tạo file Excel...' });
                const filterPayload = {
                    checkStatus: this.filters.checkStatus || [],
                    searchCode: this.filters.searchCode || null,
                    timeRange: this.filters.timeRange || null,
                    departmentAdmin: this.filters.departmentAdmin || null,
                    formBills: this.filters.formBills || null,
                    approvePaymentStatus: this.activeTab,
                    billType: this.filters.selectedBillType || null,
                    fillBillAddress: this.filters.fillBillAddress || null,
                    isValid: this.filters.isValid !== undefined ? this.filters.isValid : null,
                    company: this.filters.company || null,
                    actualPaymentDateRange: this.filters.actualPaymentDateRange || null,
                    isHDHLMode: true
                };

                const res = await this.$axios.post(`${API_URL}/bills/export-hdhl`, filterPayload, {
                    headers: { 'X-Authorization': `Bearer ${this.$app.token}` },
                    responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Xuất báo cáo _ phiếu chi điện tử.xlsx');
                document.body.appendChild(link);
                link.click();
                link.remove();
                
                this.$notify.success({ title: 'Thành công', message: 'Tải file Excel thành công!' });
            } catch (err) {
                console.error("Lỗi khi tải file: ", err);
                this.$notify.error({ title: 'Lỗi', message: 'Tải file thất bại!' });
            }
        }
    }
}
</script>

<style scoped>
@keyframes popupFadeIn {
  0% { opacity: 0; transform: translateY(10px); }
  100% { opacity: 1; transform: translateY(0); }
}
.animate-popupFadeIn {
  animation: popupFadeIn 0.3s forwards;
}
::v-deep .el-table .success-row {
  background: #1d7ce25d !important;
}
</style>
